import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {ConditionalSection, QuoteFormConditionalSection} from 'Quoting/components/shared/QuoteFormConditionalSection';
import {VALUE_NOT_AVAILABLE} from 'Quoting/utils/utilities';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {FormRowGrid, GridRowProps} from '../../../../shared/GridRow';
import {QuoteFormElement} from '../../../../shared/QuoteFormElement';
import {FormWrapper} from '../../../../shared/QuoteFormWrapper';
import {getParentSchedulePath} from '../Common/PropertyPaths';

const RecurrenceBenefit = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const parentPath = getParentSchedulePath(selectedPlan?.planIndex);

  const recurrenceDetailsPath = `${parentPath}.recurrenceDetails`;
  const selectedPlanCd =
    getQuoteFieldValue<string>(`benefitPackagingDetail.plans[${selectedPlan?.planIndex}].planCd`) ??
    VALUE_NOT_AVAILABLE;

  const isGVCI4Plan = selectedPlanCd === 'GVCI4';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'critical-illness-recurrence-benefit-row-1'},
      items: [
        {
          key: 'benefitSchedule.recurrenceDetails.separationPeriodCd',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={'CIRecurrenceBenefit.separationPeriodCd'}
              label="Separation Period (Months)"
              value={getQuoteFieldValue(`${recurrenceDetailsPath}.separationPeriodCd`)}
              id={`${recurrenceDetailsPath}.separationPeriodCd`}
              onChange={e => updateQuoteFieldValue(`${recurrenceDetailsPath}.separationPeriodCd`, e.target.value)}
              required
              disabled
            />
          ),
          props: {xs: 6, sm: 6, md: 6},
        },
        {
          key: 'benefitSchedule.recurrenceDetails.maxNumberOfRecurrencesCd',
          hidden: isGVCI4Plan,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={'CIRecurrenceBenefit.maxNumberOfRecurrencesCd'}
              label="Maximum Number of Recurrences"
              value={getQuoteFieldValue(`${recurrenceDetailsPath}.maxNumberOfRecurrencesCd`)}
              id={`${recurrenceDetailsPath}.maxNumberOfRecurrencesCd`}
              onChange={e => updateQuoteFieldValue(`${recurrenceDetailsPath}.maxNumberOfRecurrencesCd`, e.target.value)}
              required
              disabled
            />
          ),
          props: {xs: 6, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

export const RecurrenceOfBenefitsForSameCriticalIllnessBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const parentPath = getParentSchedulePath(selectedPlan?.planIndex);
  const isRecurrenceAppliedPath = `${parentPath}.isRecurrenceApplied`;

  const recurrenceBenefit: ConditionalSection[] = [
    {
      Component: RecurrenceBenefit,
      key: 'RecurrenceBenefit',
      label: 'RECURRENCE BENEFIT',
      disabled: true,
      isApplied: getQuoteFieldValue(isRecurrenceAppliedPath),
      onToggleVisibility: (visibility: boolean) => updateQuoteFieldValue(isRecurrenceAppliedPath, visibility),
    },
  ];

  return (
    <FormWrapper title="Recurrence Of Benefits For Same Critical Illness" collapsible withSeparator>
      <QuoteFormConditionalSection sections={recurrenceBenefit} />
    </FormWrapper>
  );
};
